export default __webpack_public_path__ + "static/icon-smoking-33f67e8dc13b7c61ef84546be214b695.svg";